import React from 'react';
import AdRow from '../Ads/AdRow.jsx';

// TODO remove all the template-items etc when we no longer use the template engine

const PageWithoutSidebarsTVguide = ({children, boxArticles}) =>
  <div>

    <AdRow />

    <div className="row wrapper">
      <div className="template-item col-md-12">
        { children }
      </div>
    </div>
    <div className="row wrapper">
      <div className="template-item col-md-12">
        { boxArticles }
      </div>
    </div>

  </div>;

export default PageWithoutSidebarsTVguide;



// WEBPACK FOOTER //
// ./src/component/Page/PageWithoutSidebarsTVguide.jsx